import { useState } from 'react';
import { BiMenu } from 'react-icons/bi';
import { LogoutIconMobile, SettingsIconMobile } from '../../assets/icons/icons';
import Logo from '../ui/Logo';
import mainNavItems from '../../constants/sideNavConstants';
import NavItem, { NavItemProps } from './NavItem';
import { useAuth } from '../../stores/AuthContext';

const SideNavMobile = () => {
  const { logout } = useAuth();
  const [toggleMenu, setToggleMenu] = useState(false);

  const openSettings = () => {
    const dlg = document.getElementById(
      'settings-modal'
    ) as HTMLDialogElement | null;
    dlg?.showModal();
    setToggleMenu(false);
  };

  const bottomNavItems = [
    {
      label: 'Settings',
      icon: <SettingsIconMobile />,
      activeIcon: <SettingsIconMobile />,
      to: '#',
      onClick: openSettings,
    },
    {
      label: 'Sign Out',
      icon: <LogoutIconMobile />,
      activeIcon: <LogoutIconMobile />,
      to: '/',
      onClick: () => {
        logout();
        setToggleMenu(false);
      },
    },
  ];

  return (
    <>
      <div className="flex justify-between items-center px-4 py-2 shadow-md bg-base-200">
        <Logo color="orange" />
        <button
          type="button"
          onClick={() => setToggleMenu(true)}
          className="btn btn-ghost text-2xl"
        >
          <BiMenu />
        </button>
      </div>

      {toggleMenu && (
        <div
          role="button"
          tabIndex={0}
          aria-label="Close menu overlay"
          className="fixed inset-0 bg-[#000c] bg-opacity-40 z-40"
          onClick={() => setToggleMenu(false)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setToggleMenu(false);
            }
          }}
        />
      )}

      {/* Slide-in Menu */}
      <div
        className={`fixed top-0 left-0 h-full w-72 bg-base-100 shadow-lg z-50 transform transition-transform duration-300 ${
          toggleMenu ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex justify-between items-center p-4">
          <Logo color="orange" />
          <button
            type="button"
            className="btn btn-sm btn-circle"
            onClick={() => setToggleMenu(false)}
          >
            ✕
          </button>
        </div>

        <div className="px-4 pt-4">
          <div className="overflow-y-auto h-[calc(100vh-300px)]">
            <ul className="menu gap-2 p-0">
              {mainNavItems.map((item) => (
                <NavItem
                  key={item.to}
                  label={item.label}
                  icon={item.icon}
                  to={item.to}
                  isActive
                  isCollapsed={false}
                  onClick={() => setToggleMenu(false)}
                  subMenu={item.subMenu as NavItemProps[]}
                />
              ))}
              {bottomNavItems.map((item) => (
                <NavItem
                  key={item.to}
                  label={item.label}
                  icon={item.icon}
                  to={item.to}
                  isActive={false}
                  isCollapsed={false}
                  onClick={item.onClick}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideNavMobile;
